import React, { useState, useEffect } from "react";

// Components
import Main from "./Quotation/Main";
import Form from "./Quotation/Form";
import moment from "moment";

import {
  getData,
  getDocStatusColour,
  getAlert,
  getMaxDocNo,
} from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";
import Navbar from "../../components/Modal/Navbar";

const Quotation = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [statusColours, setStatusColours] = useState([]);
  const [cachedStatusColours, setCachedStatusColours] = useState(null); // Cache for status colors
  /* The line `const [maxDocNo, setMaxDocNo] = useState();` is declaring a state variable `maxDocNo`
  using the `useState` hook in React. */
  const [maxDocNo, setMaxDocNo] = useState();
  const [startDate, setStartDate] = useState(() => {
    const storedStartDate = localStorage.getItem("startDate");
    // เก็บเป็น BE (พ.ศ.)
    return (
      storedStartDate ||
      moment().startOf("month").add(543, "year").format("YYYY-MM-DD")
    );
  });

  const [endDate, setEndDate] = useState(() => {
    const storedEndDate = localStorage.getItem("endDate");
    return (
      storedEndDate ||
      moment().endOf("month").add(543, "year").format("YYYY-MM-DD")
    );
  });



  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(true); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const parseBEDate = (dateStr) => {
    return moment(dateStr, ["YYYY-MM-DD", "DD-MM-YYYY", "DD/MM/YYYY"], true);
  };

  const convertBEtoAD = (dateStr) => {
    return parseBEDate(dateStr)
      .subtract(543, "year")
      .format("YYYY-MM-DD");
  };

  const fetchRealtime = async (updateMaxDocNo = true, allDates = false) => {

    try {
      // เก็บ พ.ศ. ลง localStorage เพื่อกลับมาแสดงผลต่อได้
      localStorage.setItem("startDate", startDate);
      localStorage.setItem("endDate", endDate);

      const startAD = convertBEtoAD(startDate);
      const endExclusiveAD = parseBEDate(endDate)
        .subtract(543, "year")
        .add(1, "day")
        .format("YYYY-MM-DD");

      // Optimized: ใช้ index-friendly query + เพิ่ม TOP ถ้าไม่ allDates
      const whereClause = allDates
        ? "1=1 ORDER BY Doc_Date DESC, Doc_No DESC"
        : ` Doc_Date >= '${startAD}' AND Doc_Date < '${endExclusiveAD}' ORDER BY Doc_Date DESC, Doc_No DESC`;
// console.debug(" whereClause: ", whereClause);

      // Parallel execution: โหลดข้อมูลพร้อมกัน
      const promises = [getData("API_0601_QT_H", whereClause)];

      if (!cachedStatusColours) {
        promises.push(getDocStatusColour("QT", "Doc_Status"));
      }

      if (updateMaxDocNo) {
        promises.push(
          getData(
            "API_0601_QT_H",
            "1=1 ORDER BY Doc_ID DESC OFFSET 0 ROWS FETCH NEXT 1 ROWS ONLY"
          )
        );
      }

      const results = await Promise.all(promises);
      let masterList, docStatusColour, findMaxDocNo;

      if (!cachedStatusColours) {
        [masterList, docStatusColour, findMaxDocNo] = results;
      } else {
        docStatusColour = cachedStatusColours;
        if (updateMaxDocNo) {
          [masterList, findMaxDocNo] = results;
        } else {
          [masterList] = results;
        }
      }

      if (masterList?.length > 0) {
        setDataMasterList(masterList);
      }

      if (docStatusColour?.length > 0) {
        setStatusColours(docStatusColour);
        if (!cachedStatusColours) {
          setCachedStatusColours(docStatusColour);
        }
      }

      if (updateMaxDocNo && findMaxDocNo) {
        const maxDoc = getMaxDocNo(findMaxDocNo, "QT");
        setMaxDocNo(maxDoc);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };
  const onPageInsert = () => {
    setMode("I");
    // เมื่อสร้างใหม่ ให้อัพเดท maxDocNo  
    fetchRealtime(true);
  };

  const onRowSelected = (docNo) => {
    setMaxDocNo(docNo);
    setMode("U");
    // ไม่อัพเดท maxDocNo เพราะใช้ docNo ที่เลือก
    fetchRealtime(false);
  };

  const onRevise = (docNo) => {
    setMaxDocNo(docNo);
    setMode("R");
    fetchRealtime(false);
  };

  return (
    <div className="PurchaseRequest">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  statusColours={statusColours}
                  name={"ใบเสนอราคา"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(docNo) => onRowSelected(docNo)}
                  onRevise={(docNo) => onRevise(docNo)}
                  getReport={getReport}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  startDate={startDate}
                  endDate={endDate}
                  fetchRealtime={fetchRealtime}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ใบเสนอราคา"}
                  maxDocNo={maxDocNo}
                  getReport={getReport}
                  setMaxDocNo={setMaxDocNo}
                  setMode={setMode}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quotation;
